import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { LogIn } from "lucide-react";

/** Modal prompt shown when an anonymous user clicks a gated action. */
export default function SignInPromptModal({ open, onOpenChange, action }) {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="border"
        style={{
          backgroundColor: "#FBFAFD",
          borderColor: "#D9D8E4",
          borderRadius: 12,
          fontFamily: '"Nunito Sans", sans-serif',
          maxWidth: 460,
        }}
        data-testid="sign-in-prompt"
      >
        <DialogHeader>
          <DialogTitle
            style={{
              fontFamily: '"Fraunces", Georgia, serif',
              fontWeight: 600,
              fontSize: 22,
              color: "#1B1F4B",
            }}
          >
            Sign in to continue
          </DialogTitle>
          <DialogDescription
            style={{ color: "#6C6B85", fontSize: 14, lineHeight: 1.6 }}
          >
            {action || "This action"} is available to signed-in roles.
            WHOLE Neighborhoods uses a role picker — no account required.
            Choose how you want to enter.
          </DialogDescription>
        </DialogHeader>

        <ul
          style={{
            fontSize: 13,
            color: "#272636",
            lineHeight: 1.7,
            paddingLeft: 18,
            margin: "8px 0 0",
          }}
        >
          <li>Owner / Builder — to save designs and start projects.</li>
          <li>Architect — to publish designs and respond to consultations.</li>
          <li>City Staff — to review submissions.</li>
        </ul>

        <DialogFooter className="mt-2">
          <button
            className="wn-btn wn-btn-tertiary"
            onClick={() => onOpenChange(false)}
            data-testid="continue-browsing-btn"
          >
            Continue browsing
          </button>
          <button
            className="wn-btn wn-btn-primary"
            onClick={() => {
              onOpenChange(false);
              navigate("/sign-in");
            }}
            data-testid="go-sign-in-btn"
          >
            <LogIn size={16} />
            Go to sign in
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
